import { useContext } from "react"
import { GoButton, MutateButton } from "@imago/api-client-for-react"
import { useInstallApp } from '@imago/api-client-for-react/pwa'
import { PageContext } from "./PatientsApp.tsx"
import { useProfile } from "../api.ts"

export function Hello({children}: {children?: any}) {
	const { shortName } = useProfile()!
	const page = useContext(PageContext)
	const installApp = useInstallApp()

	return <>
		<hgroup className="hello">
			<p className="display-large">Hello {shortName}!</p>
			<div role="toolbar">
				{page !== 'account' ? <GoButton href="/account">
					<span className="material-symbols-outlined">manage_accounts</span>
				</GoButton> : <></>}
				{page === 'account' && installApp ? <>
					<MutateButton className="only-on-expanded-plus" mutation={installApp}>
						<img src={new URL('../icons/any.png?as=png&height=32', import.meta.url).toString()} height={16}/>Install Imago app
					</MutateButton>
				</> : <></>}
			</div>
		</hgroup>
		{page === 'account' && installApp ? <>
			<MutateButton className="high-prio only-on-medium-minus" mutation={installApp}>
				<img src={new URL('../icons/any.png?as=png&height=32', import.meta.url).toString()} height={16}/>Install Imago app
			</MutateButton>
		</> : <></>}
		{children}
		<hr data-total/>
	</>
}
